export const MODEL_CONFIG = {
  TYPE: {
    FORM: 'form',
    GRID: 'grid',
    LIST: 'list'
  },

  USER: {
    MODEL: 'com.axelor.auth.db.User',
    FIELDS: [
      'id',
      'fullName',
      'employee',
      'employee.secondaryCustomsDepartment'
    ]
  },

  CARDS: {
    MODEL: 'com.axelor.apps.registration.db.RegistrationCard',
    MODEL_INSPECTORS: 'com.axelor.auth.db.User',
    ALLOW_ENTRY_ACTION: 'action-group-registration-card-allow-entry',
    FINISH_ACTION: 'action-group-registration-card-general-status-finish[3]',
    FINISH_ACTION_3: 'action-group-registration-card-general-status-finish[3]',
    FINISH_ACTION_7: 'action-group-registration-card-general-status-finish[7]',
    PROHIBIT_ENTRY_ACTION: 'action-group-registration-card-prohibit-entry',
    VIEW: {
      FORM: 'registration-card-form',
      GRID: 'registration-card-grid'
    },
    PHOTO_FIELDS: ['vehiclePhotoEntry', 'vehiclePhotoDeparture'],
    FIELDS_TABLE: [
      'checkInTime',
      'checkOutTime',
      'customsDepartment',
      'generalStatusSelect',
      'id',
      'recordingMethod',
      'registrationInTime',
      'registrationOutTime',
      'statusDecision',
      'statusSelect',
      'type',
      'vehicleNumber',
      'vehiclePhotoEntry',
      'vehiclePhotoDeparture',
      'vehicleType',
      'vehicleInfo',
      'oldVehicleNumber',
      'piRequests',
      'driver',
      'vgk',
      'photoRecordings',
      'archived',
      'arrivalTime',
      'attrs',
      'containerTemporaryImportExportCITD',
      'controlTime',
      'createdBy',
      'createdOn',
      'idkInspection',
      'importId',
      'importOrigin',
      'meansTs',
      'processInstanceId',
      'registrationNumber',
      'rpmEvent',
      'sentToTstk',
      'sequence',
      'tdAndCitdTime',
      'temporaryImportExportCITD',
      'temporaryImportExportTSLP',
      'updatedBy',
      'updatedOn'
    ],
    FIELDS_VIEW: [
      'piRequests',
      'meansTs',
      'vehiclePhotoEntry',
      'type',
      'containerTemporaryImportExportCITD',
      'photoRecordings',
      'vehicleNumber',
      'vgk',
      'temporaryImportExportTSLP',
      'vehicleType',
      'generalStatusSelect',
      'checkInTime',
      'vehicleInfo',
      'rpmEvent',
      'updatedOn',
      'temporaryImportExportCITD',
      'customsDepartment',
      'statusSelect',
      'idkInspection',
      'driver',
      'registrationInTime',
      'registrationNumber',
      'registrationOutTime',
      'recordingMethod'
    ],
    TRANSPORT_CONTROL_FETCH: {
      FIELDS: [
        "actWeighing.status",
        "actWeighing.creatingDate",
        "actWeighing.totalWeight",
        "type",
        "containerTemporaryImportExportCITD",
        "actWeighing.customsDepartment",
        "blankSpecial",
        "actWeighing.trailerNumber",
        "actWeighing.photo",
        "actWeighing.trailerCountry",
        "vehicleNumber",
        "vehicleType",
        "updatedOn",
        "temporaryImportExportCITD",
        "idkInspection",
        "actWeighing.trailerTransportKind",
        "actWeighing.length",
        "driver",
        "registrationInTime",
        "recordingMethod",
        "piRequests",
        "actWeighing.mainTransportKind",
        "actWeighing.height",
        "vehiclePhotoEntry",
        "actWeighing.countAxesTrailer",
        "actWeighing.actNumber",
        "actWeighing.recordingMethod",
        "photoRecordings",
        "actWeighing.axles",
        "actWeighing.countAxesMain",
        "vgk",
        "temporaryImportExportTSLP",
        "actWeighing.width",
        "generalStatusSelect",
        "actWeighing.driver",
        "actWeighing.totalWeightTrailer",
        "checkInTime",
        "transportationCommodity",
        "vehicleInfo",
        "rpmEvent",
        "actWeighing.totalWeightMain",
        "actWeighing",
        "customsDepartment",
        "statusSelect",
        "special",
        "actWeighing.transportNumber",
        "registrationNumber",
        "activities",
        "actWeighing.mainCountry",
        "registrationOutTime",
        "ePermit"
      ],
      RELATED: {
        "special": [
          "registrationNumber",
          "registrationDate",
          "department",
          "addInfo",
          "carrierName",
          "carrierInn",
          "carrierPhone",
          "carrierCountry",
          "driverFullName",
          "driverInn",
          "driverCountry",
          "representativeFullName",
          "representativePhone",
          "cargoName",
          "cargoLength",
          "cargoWidth",
          "cargoHeight",
          "cargoWeight",
          "vehicleType",
          "vehicleBrandTractor",
          "vehicleStateNumber",
          "vehicleDistanceBetweenAxes",
          "vehicleAxleLoad",
          "vehicleSlopeOfTheAxis",
          "vehicleAxlesTractorNumber",
          "trailerType",
          "trailerStateNumber",
          "trailerBrand",
          "trailerAxleNumber",
          "trailerWeight",
          "trailerLoadCapacity",
          "transportationType",
          "travelPeriodFrom",
          "travelPeriodTo",
          "placeOfDeparture",
          "placeOfArrival",
          "conditionsOfCarriage",
          "dateOfApproval",
          "travelDateTime"
        ],
        "blankSpecial": [
          "specNumber",
          "transportationType",
          "travelPeriodFrom",
          "travelPeriodTo",
          "route",
          "resolutionIssuedBy",
          "issuedDate",
          "conditionsOfCarriage",
          "carrierName",
          "carrierAddress",
          "carrierPhone",
          "driver",
          "vehicleNumber",
          "tractorAxles",
          "trailerNumber",
          "trailerAxles",
          "massWithCargo",
          "cargoName",
          "axleDistance",
          "axleLoad",
          "vehicleLength",
          "vehicleWidth",
          "vehicleHeight"
        ]
      }
    }
  },

  MEANS_TS: {
    MODEL: 'com.axelor.apps.dictionary.db.MeansTransportation',
    TRANSPORT_TYPE_MODEL: 'com.axelor.apps.dictionary.db.TransportType',
    VIEW: {
      FORM: 'means-transportation-form',
      GRID: 'means-transportation-grid'
    },
    FIELDS: [
      'vehicleNumber',
      'vin',
      'transportRegNumber',
      'model',
      'version',
      'bodyId',
      'chassisId',
      'transportType',
      'transportType.main',
      'transportType.code',
      'transportBrand',
      'transportKind',
      'country'
    ]
  },

  TRANSPORTATION_COMMODITY: {
    MODEL: 'com.axelor.apps.dictionary.db.TransportationCommodity',
    FIELDS: [
      'id',
      'product',
      'version',
      'transport.id',
      'transport.vehicleNumber',
      'transport.vin',
      'transport.transportRegNumber',
      'transport.model',
      'transport.bodyId',
      'transport.chassisId',
      'transport.transportType',
      'transport.transportType.main',
      'transport.transportType.code',
      'transport.transportBrand',
      'transport.transportKind',
      'transport.country',
      'transport.version'
    ]
  },

  DRIVER: {
    MODEL: 'com.axelor.apps.dictionary.db.RegisteredPerson',
    VIEW: {
      FORM: 'registered-person-driver-form',
      GRID: 'registered-person-driver-grid'
    },
    FIELDS_VIEW: [
      'citizenshipIndicator',
      'companyName',
      'country',
      'docIssueDate',
      'docNumber',
      'documentDate',
      'email',
      'firstName',
      'issuingAuthority',
      'kindIdentityCard',
      'lastName',
      'mainAddressApartmentNumber',
      'mainAddressCity',
      'mainAddressCountry',
      'mainAddressDistrict',
      'mainAddressHouseNumber',
      'mainAddressLocality',
      'mainAddressRegion',
      'mainAddressStreet',
      'okpo',
      'patronymic',
      'personalINN',
      'phone',
      'seriesDoc',
      'taxpayerID',
      'type'
    ]
  },

  PI_REQUESTS: {
    MODEL: 'com.axelor.apps.preliminaryinformation.db.PIRequest',
    FIELDS: [
      'uinp',
      'totalPrice',
      'meansTs',
      'dateTimeSubmission',
      'source',
      'updatedOn',
      'createdOn',
      'customsDepartment',
      'consignmentWeight',
      'sender',
      'createdBy',
      'recipient',
      'vehicleNumber',
      'currency',
      'estimatedArrivalDate',
      'recordingMethod',
      'status',
      'preliminaryInfo'
    ]
  },

  PRELIMINARY_INFO: {
    MODEL: 'com.axelor.apps.preliminaryinformation.db.PreliminaryInfo',
    FIELDS: [
      'id',
      'checkpoint',
      'arrivalLocationArrivalDateTime',
      'other',
      'departureAirport',
      'registrationNumberTirCarnet',
      'meansTs',
      'guarantee',
      'customsOfficeOfDestination',
      'loadingUnloadingGoods',
      'intermediateCountries',
      'sanEpidDecisions',
      'transitDeclaration',
      'createdOn',
      'infoIdentificationMeans',
      'deniedReason',
      'vetDecisions',
      'purposeOfPreliminaryInformation',
      'carrierRepresentatives',
      'transportType',
      'departureStation',
      'commodityConsignments',
      'commodityConsignment',
      'declarant',
      'specialPermission',
      'shipmentIdentificationNumber',
      'changedMeansTransportationArrivalCheckpoint',
      'changedMeansTs',
      'minTransDecisions',
      'carrierInformation',
      'departureCountry',
      'codeFeaturesTransitTransportMeans',
      'customsOfficeDeparture',
      'technicalPassport',
      'signTransportationTirCarnet',
      'updatedOn',
      'destinationCountry',
      'temporaryImportExportCITD',
      'airport',
      'customsDepartment',
      'submitterType',
      'license',
      'railwayStation',
      'permissionForm',
      'fitoDecisions',
      'createdBy',
      'availabilityMeansIdentification',
      'status',
      'version',
      'virtualLicense'
    ]
  },

  COMMODITY_CONSIGNMENT: {
    MODEL: 'com.axelor.apps.dictionary.db.CommodityConsignment',
    FIELDS: [
      'id',
      'goods.address',
      'goods',
      'goodsTotalAmount',
      'totalNetWeight',
      'grossWeight',
      'currency',
      'totalPrice',
      'cargoTotalAmount',
      'containerDetails',
      'sender',
      'recipient',
      'billLading',
      'version',
      'guarantee',
      'address',
      'customsDepartment'
    ],
    RELATED: ['containerDetails', 'guarantee']
  },

  CONTAINER_DETAILS: {
    MODEL: 'com.axelor.apps.dictionary.db.ContainerDetails',
    FIELDS: ['containerIdentifier', 'countryIdentifier']
  },

  GOODS: {
    MODEL: 'com.axelor.apps.dictionary.db.Goods',
    FIELDS: [
      'grossWeight',
      'quantity',
      'price',
      'quantityGoodsAccordanceUnit',
      'name',
      'cargoQuantity',
      'unit',
      'additionalUnit',
      'currency',
      'indexNumber',
      'cargoPartQuantity',
      'submittedDocument',
      'netWeight',
      'rate',
      'price',
      'productProductionDate',
      'tnved.code',
      'cargoPackagePalletDetails',
      'cargoPackagePalletDetails.packageAvailabilityCode',
      'cargoPackagePalletDetails.packageQuantity',
      'cargoPackagePalletDetails.packingType',
      'cargoPackagePalletDetails.customsDepartment',
      'cargoPackagePalletDetails.cargoDescriptionText',
      'address.country',
      'address.region',
      'address.city',
      'address.district',
      'address.locality',
      'submittedDocument',
      'customsDepartment.name'
    ],
    RELATED: ['cargoPackagePalletDetails', 'submittedDocument', 'address']
  },

  CARGO_PACKAGE_PALLET_DETAILS: {
    MODEL: 'com.axelor.apps.dictionary.db.CargoPackagePalletDetails',
    FIELDS: ['packageAvailabilityCode', 'packageQuantity', 'packingType']
  },

  CARRIER_INFORMATION: {
    MODEL: 'com.axelor.apps.preliminaryinformation.db.CarrierInformation',
    FIELDS: [
      'id',
      'type',
      'lastName',
      'firstName',
      'patronymic',
      'personalINN',
      'citizenshipIndicator',
      'seriesDoc',
      'issuingAuthority',
      'docNumber',
      'documentDate',
      'country',
      'mainAddressCountry',
      'mainAddressLocality',
      'mainAddressHouseNumber',
      'mainAddressRegion',
      'mainAddressCity',
      'mainAddressApartmentNumber',
      'mainAddressDistrict',
      'mainAddressStreet',
      'email',
      'phone',
      'version',
      'okpo',
      'companyName',
      'taxpayerID'
    ]
  },

  REGISTERED_PERSON: {
    MODEL: 'com.axelor.apps.dictionary.db.RegisteredPerson',
    LIST_FIELDS: ['id', 'fullName', 'taxpayerID', 'personalINN', 'companyName', 'firstName', 'lastName', 'patronymic'],
    FIELDS: [
      'id',
      'type',
      'lastName',
      'firstName',
      'patronymic',
      'personalINN',
      'citizenshipIndicator',
      'seriesDoc',
      'issuingAuthority',
      'docNumber',
      'documentDate',
      'country',
      'mainAddressCountry',
      'mainAddressLocality',
      'mainAddressHouseNumber',
      'mainAddressRegion',
      'mainAddressCity',
      'mainAddressApartmentNumber',
      'mainAddressDistrict',
      'mainAddressStreet',
      'email',
      'phone',
      'version',
      'okpo',
      'companyName',
      'taxpayerID'
    ]
  },

  CARRIER_REPRESENTATIVES: {
    MODEL: 'com.axelor.apps.preliminaryinformation.db.CarrierRepresentatives',
    FIELDS: [
      'id',
      'type',
      'lastName',
      'firstName',
      'patronymic',
      'personalINN',
      'citizenshipIndicator',
      'seriesDoc',
      'issuingAuthority',
      'docNumber',
      'documentDate',
      'country:name',
      'mainAddressLocality',
      'mainAddressHouseNumber',
      'mainAddressRegion',
      'mainAddressCity',
      'mainAddressApartmentNumber',
      'mainAddressDistrict',
      'mainAddressStreet',
      'email',
      'phone',
      'version'
    ]
  },

  DECLARANT: {
    MODEL: 'com.axelor.apps.preliminaryinformation.db.Declarant',
    FIELDS: [
      'id',
      'type',
      'lastName',
      'firstName',
      'patronymic',
      'personalINN',
      'citizenshipIndicator',
      'seriesDoc',
      'issuingAuthority',
      'docNumber',
      'documentDate',
      'country:name',
      'mainAddressLocality',
      'mainAddressHouseNumber',
      'mainAddressRegion',
      'mainAddressCity',
      'mainAddressApartmentNumber',
      'mainAddressDistrict',
      'mainAddressStreet',
      'email',
      'phone',
      'version'
    ]
  },

  VET_DECISION: {
    MODEL: 'com.axelor.apps.preliminaryinformation.db.VETDecision',
    FIELDS: ['id', 'status', 'description', 'endDate', 'startDate', 'version']
  },

  SANEPID_DECISION: {
    MODEL: 'com.axelor.apps.preliminaryinformation.db.SanEpidDecision',
    FIELDS: ['id', 'status', 'description', 'endDate', 'startDate', 'version']
  },

  MINTRANS_DECISION: {
    MODEL: 'com.axelor.apps.preliminaryinformation.db.MinTransDecision',
    FIELDS: ['id', 'status', 'description', 'endDate', 'startDate', 'version']
  },

  FITO_DECISION: {
    MODEL: 'com.axelor.apps.preliminaryinformation.db.FITODecision',
    FIELDS: ['id', 'status', 'description', 'endDate', 'startDate', 'version']
  },

  CUSTOMS_AUTHORITY_DECISION: {
    MODEL: 'com.axelor.apps.dictionary.db.DecisionCustomsAuthority',
    FIELDS: ['id', 'fullName', 'name', 'code']
  },

  RAILWAY_STATION: {
    MODEL: 'com.axelor.apps.dictionary.db.RailwayStation',
    FIELDS: ['id', 'fullName', 'name', 'code']
  },

  DENIED_REASON: {
    MODEL: 'com.axelor.apps.dictionary.db.DeniedReason',
    FIELDS: ['id', 'name']
  },

  COUNTRIES: {
    MODEL: 'com.axelor.apps.base.db.Country'
  },

  KIND_IDENTITY_CARD: {
    MODEL: 'com.axelor.apps.dictionary.db.KindsIdentityDocuments'
  },

  TRANSPORT_TYPE: {
    MODEL: 'com.axelor.apps.dictionary.db.TransportType'
  },

  TRANSPORT_KIND: {
    MODEL: 'com.axelor.apps.dictionary.db.TransportKind'
  },

  TRANSPORT_BRAND: {
    MODEL: 'com.axelor.apps.dictionary.db.MeansTransportationBrand'
  },

  PHOTO_RECORDINGS: {
    MODEL: 'com.axelor.apps.registration.db.PhotoRecording',
    MODEL_TYPE: 'com.axelor.apps.dictionary.db.VehicleType',
    MODEL_MODEL_AT: 'com.axelor.apps.dictionary.db.CameraVehicleMark',
    MODEL_COLOR: 'com.axelor.apps.dictionary.db.VehicleColor',
    CAMERA: 'com.axelor.apps.dictionary.db.Camera',
    DIRECTION_MOVE: 'com.axelor.apps.dictionary.db.DirectionMovementVehicle',
    REMOVED_BY: 'com.axelor.auth.db.User',
    CUSTOMS_DEPARTMENT: 'com.axelor.apps.dictionary.db.Subdivision',
    FIELDS_TABLE: ['vehicleNumber', 'snapshotTime', 'camera', 'recordingMethod']
  },

  VGK: {
    MODEL: 'com.axelor.apps.registration.db.Vgk',
    FIELDS_TABLE: [
      'sourceId',
      'weightSystem',
      'trailerNumber',
      'violation',
      'weighingType',
      'transportNumber',
      'totalWeight',
      'photo',
      'creatingDate',
      'status',
      'customsDepartment'
    ],
  },

  AXIS: {
    MODEL: 'com.axelor.apps.registration.db.Axis',
  },

  DIMENSION: {
    MODEL: 'com.axelor.apps.registration.db.Dimension',
  },

  DOWNHILL: {
    MODEL: 'com.axelor.apps.registration.db.Downhill',
  },

  VEHICLE_TSTK: {
    MODEL: 'com.axelor.apps.registration.db.VehicleTstk',
  },

  VGK_PHOTO: {
    MODEL: 'com.axelor.apps.registration.db.VgkPhoto',
  },



  IDK: {
    MODEL: 'com.axelor.apps.registration.db.IdkInspection',
    XRAY_MODEL: 'com.axelor.apps.registration.db.XrayPart',
    SCAN_OBJECT: 'com.axelor.apps.registration.db.ScanObject',
    INSPECTION_RESULTS: 'com.axelor.apps.registration.db.InspectionResult',
    IDK_FORM_DATA: 'com.axelor.apps.registration.db.IdkFormData',
    IDK_DOCUMENT: 'com.axelor.apps.registration.db.IdkDocument',
    SCAN_OBJECT_PHOTO: 'com.axelor.apps.registration.db.ScanObjectPhoto',
    FIELDS_TABLE: [
      'sourceId',
      'documents',
      'trailerNumber',
      'xrayParts',
      'scanObjects',
      'description',
      'customsDepartment',
      'lots',
      'xrayTrackNumber',
      'operStatus',
      'vehicleNumber',
      'xrayStatus',
      'formData',
      'idkSystem',
      'recordingMethod',
      'creationDateTime'
    ]
  },

  RPM: {
    MODEL: 'com.axelor.apps.registration.db.RpmEvent',
    FIELDS_TABLE: [
      'vehiclePhotoLicensePlate',
      'eventId',
      'rpmPhotos',
      'processingAccuracy',
      'maxSigmaVal',
      'maxNeutronVal',
      'priority',
      'dispositionCode',
      'eventComment',
      'vehiclePhoto',
      'operator',
      'customsDepartment',
      'sequence',
      'rpmIndicators',
      'vehicleNumber',
      'equipmentName',
      'rpmSystem',
      'maxGammaVal',
      'vehicleCountry',
      'recordingMethod',
      'creationDateTime'
    ],
    INDICATOR_MODEL: 'com.axelor.apps.registration.db.RpmIndicator',
    PHOTOS_MODEL: 'com.axelor.apps.registration.db.RpmPhotography',
  },

  PIREQUEST: {
    MODEL: 'com.axelor.apps.preliminaryinformation.db.PIRequest'
  },

  PRELIMINARYINFO: {
    MODEL: 'com.axelor.apps.preliminaryinformation.db.PreliminaryInfo'
  },

  EVENT_CARD: {
    MODEL: 'com.axelor.apps.dictionary.db.EventLogCustomsInspection',
    FIELDS: [
      "executive",
      "act",
      "photoFixation1",
      "registrationCard",
      "photoFixation2",
      "photoFixation3",
      "videoFixation",
      "transitDeclaration",
      "status"
    ],
  },

  ACT_CUSTOMS_INSPECTION: {
    MODEL: 'com.axelor.apps.dictionary.db.ActCustomsInspection',
    FIELDS: ['id', 'fullName'],
    FIELDS_SELECTION: ['id', 'fullName', 'registrationNumber']
  },

  DECLARATION: {
    MODEL: 'com.axelor.apps.transitcontrolsystem.db.TransitDeclaration',
    ATTRIBUTES_ACTION: 'action-group-transit-declaration-onload,com.axelor.meta.web.MetaController:moreAttrs',
    PRINT_ACTION: 'action-group-report-transit-declaration,action-group-close-popup',
    PRINT_ACTION_ACT: 'action-group-report-transit-declaration-act,action-group-close-popup',
    DRAFT_ACTION: 'action-group-transit-declaration-draft-quotation',
    CONDUCT_ACTION: 'action-group-transit-declaration-conduct-quotation',
    CONDUCT_ACTION_2: 'action-group-transit-declaration-conduct-quotation[3]',
    FIELDS_TABLE: [
      'declarationType',
      'purposeGoods',
      'transitDeclarationDictionary.tdNumber',
      'transitPeriod',
      'transitDeclarationDictionary.shipmentStatus',
      'registrationNumber',
      'decisionCustomsAuthority',
      'typeMovementGoods',
      'declarant',
      'status'
    ],
    FIELDS: [
      'totalPrice',
      'totalNumberGoods',
      'createdOn',
      'registrationNumber',
      'lnpOfficial',
      'totalGrossWeight',
      'oneTimeAssumption',
      'declarant',
      'declarationType',
      'tdNumber',
      'commonCurrency',
      'departureCountry',
      'cargoTotalAmount',
      'customsOfficeDeparture',
      'spent',
      'updatedOn',
      'destinationCountry',
      'customsDepartment',
      'purposeGoods',
      'carrier',
      'railwayStation',
      'createdBy',
      'customsOfficeDestination',
      'totalNetWeight',
      'registrationNumberTirCarnet',
      'recordingMethod',
      'typeMovementGoods',
      'status',
      'meansTs',
      'overloadMeansTs',
      'decisionCustomsAuthority',
      'transitDeclarationDateTime',
      'passingChangeRoute',
      'transitPeriod',
      'processInstanceId',
      'transitTakeOffControl',
      'updatedBy',
      'intermediateRoute',
      'actCustomsInspection',
      'version',
      'safePackageTd',
      'guarantee',
      'identificationTool',
      'spent'
    ],
    RELATED: [
      'consignment',
      'declarationType',
      'purposeGoods',
      'typeMovementGoods',
      'declarant',
      'carrier',
      'departureCountry',
      'destinationCountry',
      'meansTs',
      'overloadMeansTs',
      'customsOfficeDeparture',
      'oneTimeAssumption',
      'customsOfficeDestination',
      'railwayStation',
      'actCustomsInspection',
      'decisionCustomsAuthority',
      'transitPeriod',
      'guarantee',
      'safePackageTd',
      'identificationTool',
      'intermediateRoute',
      'transitDeclarationDictionary'
    ]
  },

  DECLARATION_DICTIONARY: {
    MODEL: 'com.axelor.apps.transitcontrolsystem.db.TransitDeclarationDictionary',
    FIELDS: [
      'meansTs',
      'decisionCustomsAuthority',
      'lnpOfficial',
      'transitDeclarationDateTime',
      'decisionCustomsAuthority',
      'passingChangeRoute',
      'transitPeriod',
      'totalGrossWeight',
      'oneTimeAssumption',
      'processInstanceId',
      'transitTakeOffControl',
      'updatedBy',
      'departureCountry',
      'intermediateRoute',
      'actCustomsInspection',
      'updatedOn',
      'destinationCountry',
      'version',
      'purposeGoods',
      'safePackageTd',
      'guarantee',
      'identificationTool',
      'createdBy',
      'recordingMethod',
      'spent'
    ]
  },

  GUARANTEE: {
    MODEL: 'com.axelor.apps.dictionary.db.Guarantee',
    FIELDS_TABLE: [
      'id',
      'docDate',
      'docName',
      'docNumber',
      'docKindCode',
      'attachDocument',
      'escortOfficer',
      'guaranteeCertificateRegId',
      'customsTransitEnforcementMeasure',
      'guaranteePresentCode',
      'classifierOfNonProvisionOfCollateral',
      'customsDepartment'
    ]
  },

  REGISTRATION_NUMBER_TIR_CARNET: {
    MODEL: 'com.axelor.apps.dictionary.db.RegistrationNumberTirCarnet',
    FIELDS: [
      'nameOrganizationTIR',
      'identificationNumberTirCarnet',
      'serialNumberTirCarnetSheet',
      'customsDepartment',
      'archived',
      'tirCarnetSeries',
      'importId',
      'createdBy',
      'identificationNumberTirCarnetHolder',
      'id'
    ]
  },
  INFO_IDENTIFICATION_MEANS: {
    MODEL: 'com.axelor.apps.dictionary.db.InfoIdentificationMeans',
    FIELDS: ['serialNumber', 'sealerNumber', 'customsDepartment', 'id', 'preliminaryInfo']
  },

  SEAL_NUMBER: {
    MODEL: 'com.axelor.apps.transitcontrolsystem.db.SealNumberTd',
    MODEL_REFERENCE: 'com.axelor.apps.dictionary.db.SealNumber',
    FIELDS_TABLE: ['sealKg', 'cargoOperation', 'seal', 'sealNumber', 'customsDepartment']
  },

  SAFE_PACKAGE: {
    MODEL: 'com.axelor.apps.transitcontrolsystem.db.SafePackageTd',
    MODEL_REFERENCE: 'com.axelor.apps.dictionary.db.SafePackage',
    FIELDS_TABLE: ['safePackage', 'createdOn']
  },

  INTERMEDIATE_ROUTE: {
    MODEL: 'com.axelor.apps.transitcontrolsystem.db.IntermediateRoute',
    FIELDS_TABLE: ['intermediateCustomsAuthority', 'createdOn']
  },

  CITD_ROUTE: {
    MODEL: 'com.axelor.apps.temporaryimportexport.db.CITDRoute',
    FIELDS_TABLE: ['destination', 'destinationCountry']
  },

  CUSTOMS_TRANSIT: {
    MODEL: 'com.axelor.apps.dictionary.db.CustomsTransitEnforcementMeasure'
  },

  CLASSIFIER_NON_PROVISION_COLLATERAL: {
    MODEL: 'com.axelor.apps.dictionary.db.ClassifierOfNonProvisionOfCollateral'
  },

  DOCUMENT_KIND: {
    MODEL: 'com.axelor.apps.dictionary.db.ClassifierTypeDocumentInformation'
  },

  ESCORT_OFFICER: {
    MODEL: 'com.axelor.auth.db.User'
  },

  TEMPORARY_IMPORT_EXPORT_TSLP: {
    MODEL: 'com.axelor.apps.temporaryimportexport.db.TemporaryImportExportTSLP',
    ATTRIBUTES_ACTION: 'action-group-temporary-import-export-tslp-onload,com.axelor.meta.web.MetaController:moreAttrs',
    DOWNLOAD_PDF_ACTION: 'action-group-report-temporary-tslp,action-group-close-popup',
    DRAFT_ACTION: 'action-group-temporary-import-export-tslp-draft-quotation',
    CONDUCT_ACTION: 'action-group-temporary-import-export-tslp-open-quotation',
    CONDUCT_ACTION_2: 'action-group-temporary-import-export-tslp-open-quotation[4]',
    FIELDS: ['status', 'directionType', 'registrationNumber', 'createdOn']
  },

  TEMPORARY_IMPORT_EXPORT_CITD: {
    MODEL: 'com.axelor.apps.temporaryimportexport.db.TemporaryImportExportCITD',
    ATTRIBUTES_ACTION: 'action-group-temporary-import-export-citd-onload,com.axelor.meta.web.MetaController:moreAttrs',
    DOWNLOAD_PDF_ACTION: 'action-group-report-temporary,action-group-close-popup',
    DRAFT_ACTION: 'action-group-temporary-import-export-citd-draft-quotation',
    CONDUCT_ACTION: 'action-group-temporary-import-export-citd-open-quotation',
    CONDUCT_ACTION_2: 'action-group-temporary-import-export-citd-open-quotation[8]',
    FIELDS: ['status', 'directionType', 'registrationNumber', 'createdOn', 'mainVehicleNumber', 'trailersVehicleNumber', 'containersVehicleNumber', ]
  },

  ADDRESS: {
    MODEL: 'com.axelor.apps.dictionary.db.AddressBook'
  },

  CARGO_PACKAGE: {
    MODEL: 'com.axelor.apps.dictionary.db.CargoPackagePalletDetails',
    FIELDS: ['packageAvailabilityCode', 'packageQuantity', 'packingType', 'cargoDescriptionText']
  },

  SUBMITTED_DOCUMENT: {
    MODEL: 'com.axelor.apps.dictionary.db.SubmittedDocument',
    FIELDS: ['docName', 'documentType', 'docId', 'dateOfIssue', 'expirationDate', 'attachDocument']
  },

  BILL_LADING: {
    MODEL: 'com.axelor.apps.dictionary.db.BillLading',
    FIELDS: ['docName', 'documentType', 'docId', 'attachDocument', 'dateOfIssue', 'expirationDate', 'customsDepartment']
  },

  ADDITIONAL_UNIT: {
    MODEL: 'com.axelor.apps.dictionary.db.AdditionalUnit',
    FIELDS: ['id', 'fullName', 'name', 'code']
  },

  EQUIPMENT_DESCRIPTION: {
    MODEL: 'com.axelor.apps.temporaryimportexport.db.SparePartEquipment',
    FIELDS: ['id', 'equipmentName', 'goodsQuantity', 'measureUnitQualifierName', 'version']
  },

  EPERMIT: {
    MODEL: 'com.axelor.apps.registration.db.EPermit',
    FIELDS: [
      'departureCountry',
      'companyName',
      'issuerForCountry',
      'used',
      'plateNumber',
      'revoked',
      'expiresAt',
      'issuerCountry',
      'permitNumber',
      'companyId',
      'permitType',
      'qrCode',
      'issuedAt',
      'revokedAt',
      'permitYear',
      'arrivalCountry'
    ]
  },

  ACTIVITIES: {
    MODEL: 'com.axelor.apps.registration.db.Activities',
    FIELDS: [
      'id',
      'activityType',
      'reportNumber',
      'userStory',
      'staffName',
      'activityDetails',
      'activityTime',
      'customsDepartment',
      'version'
    ]
  }
};
